export const doRetry = async <T>(
  doWhat: () => T,
  tillWhen: (
    currentRetryIteration: number,
    doWhatOutput: T
  ) => Promise<'again' | 'stop'>
): Promise<T | undefined> => {
  return await doRetryRecursive(doWhat, tillWhen, 0);
};
const doRetryRecursive = async <T>(
  doWhat: () => T,
  tillWhen: (
    currentRetryIteration: number,
    doWhatOutput: T
  ) => Promise<'again' | 'stop'>,
  currentRetryIteration: number
): Promise<T | undefined> => {
  const response = await doWhat();
  if ((await tillWhen(currentRetryIteration, response)) === 'stop') {
    return response;
  }
  return await doRetryRecursive(doWhat, tillWhen, currentRetryIteration + 1);
};
